/**
 * Default values for "Create New Session" (no secrets — paste OAuth + Groq in the UI).
 */
export const DEFAULT_SKILL_IDS_LIST =
  '3, 9, 13, 15, 17, 20, 21, 26, 32, 38, 44, 57, 69, 70, 77, 106, 107, 115, 116, 127, 137, 168, 170, 174, 196, 197, 204, 229, 232, 234, 247, 250, 262, 264, 277, 278, 284, 305, 310, 323, 324, 335, 359, 365, 368, 369, 371, 375, 408, 412, 433, 436, 444, 445, 482, 502, 564, 624, 662, 710, 759, 878, 950, 953, 959, 1063, 1185, 1314, 1623, 2071, 2128, 2222, 2245, 2338, 2342, 2507, 2586, 2587, 2589, 2605, 2625, 2645, 2673, 2698, 2717, 2745';

export const DEFAULT_SERVICE_OFFERINGS = `You are a professional project analyst. Evaluate the following project details and decide whether the project matches our service offerings. Respond with only 'MATCH' or 'NO MATCH'. If you are not completely sure about the project details, respond with 'NO MATCH'.

Our Service Offerings:

1. Website Development:
   - We specialize exclusively in website development projects using CMS platforms. Supported CMS platforms include WordPress, E Commerce platforms, GoDaddy, Wix, Shopify, Webflow, Squarespace, Square and similar systems.
   - We do not provide custom development services using frameworks such as ReactJS, Laravel, etc.
   - We only work on projects that require building a website from scratch. If the project is solely about fixing or maintaining an existing website, it should be considered 'NO MATCH'.
   - The minimum budget for a website development project is $100. Projects with very low budgets (e.g., between $10–$30) are 'NO MATCH'.

2. CMS Website Issues Resolve and Maintenance:
-We provide issue fixing and troubleshooting strictly for CMS based websites only.
-This includes layout issues, responsiveness problems, speed optimization, broken sections, plugin or extension conflicts, theme related issues, CMS updates, content updates, and performance improvements.
-We also provide ongoing CMS website maintenance, regular updates, security improvements, backups, and minor feature adjustments.
-Projects involving custom coded systems, mobile apps, server side development, or non CMS platforms are NO MATCH.

Only return 'MATCH' if the project description clearly fits these criteria. Otherwise, return 'NO MATCH'.`;

export const DEFAULT_BID_WRITING_STYLE = `Write a professional freelance proposal/bid for the given project. Follow this specific format and quality level:

⸻

✅ STRUCTURE & FLOW
	1. Start immediately with a strong, natural-sounding sentence that connects with the client's main goal (skip all greetings and intros). Keep it direct and aligned with their objective — no forced hooks.
  2. Demonstrate relevant experience by referencing similar past work, ideally with a measurable or outcome-based result. Keep it short and relevant.
  3. Show understanding of the client's needs and hint at key deliverables without listing them. Emphasize what really matters in the project and how you'll approach it.
  4. End with a confident, reassuring promise tied to their end goal. Include a subtle risk reversal (e.g., revisions offered, collaboration-friendly, satisfaction focus).
	5. After the main bid, write:
Here's my previous related work according to your needs:
And then insert 2–3 portfolio links that are directly relevant to the project.
	6.	Finish with this signature:

Regards,
Amin Warind.

⸻

🎯 TONE & STYLE
	•	Human, confident, but not robotic or over-polished.
	•	No hype or dramatic exaggeration — just clarity, warmth, and a clear understanding of the client's pain points.
	•	Keep it results-focused and outcome-oriented, not feature-dumping.
	•	Make it sound like a real person who cares, not a sales pitch.

⸻

📌 EXTRA NOTES (IMPORTANT!)
: Keep it within 80 words, using a conversational, Spartan tone in Pakistani English with clear, short paragraphs for easy readability. Avoid corporate jargon
•⁠  ⁠Drop the link as it is. Don't add markdown to make it clickable
•⁠  ⁠Don't use boldface for anything.
•⁠  ⁠Do not use these characters: ; _ – — -
•⁠  ⁠as I'm copy pasting the text and bullet points come under text markdown which is not supported where I'm using
•⁠  FORMATE TEXT AND LINKS properly so I can just copy-paste it and it's easy to read
•⁠  ⁠when the project is about website put all the link of specific category
•⁠  ⁠⁠If the project is in a specific industry (e.g. dental, fashion, B2B, tech), use language that aligns with that niche.
•⁠  ⁠Don't ever start with "Hi" or "Dear" — go straight into value.`;

export const DEFAULT_PORTFOLIO_LINKS = `Food and Beverage Websites:
https://www.fizznchill.com/
https://www.tonchin.com/
https://www.farmhouseinn.com/
https://www.bluehillfarm.com/

Ecommerce Websites:
https://splendidfurnishings.com/
https://stickertitans.com/
https://cellularport.com/
https://store.cellularport.com/
https://www.oliveclothing.com/

IT Services and Technology Companies:
https://cmanetworks.com/
https://apilytech.com.au/
https://dymaxtech.com/
https://gazillionx.com/
https://e360digitalpro.com/

SaaS and Tech Websites:
https://www.helpwise.io/
https://www.loomly.com/
https://www.useproof.com/
https://www.chartmogul.com/

Branding and Creative Services:
https://artlogo.co/
https://lscarpenterstudio.com/
https://www.studio-output.com/
https://www.bureaugraphique.com/

Corporate and Consulting Websites:
https://navitasconsultinggroup.com/
https://beexecutive.co.uk/
https://ccigroupcanada.com/
https://citywideconsultant.com.au/
https://aompartner.com/

Recruitment and HR Platforms:
https://recruitswright.com/
https://billingwright.com/
https://www.coachhub.io/
https://www.futur.com/

Agency and Creative Websites:
https://www.highrise.digital/
https://www.whiteboard.is/
https://www.nothing.design/
https://www.superrb.com/

Event and Entertainment Websites:
https://thehitchmen.com/
https://hiphot.nl/
https://www.clearskybeachside.com/
https://www.tonchin.com/

Engineering and Construction Websites:
https://dgeng.com.au/
https://constructkoin.com/
https://fantasiaenterprises.com/
https://legacypreservationpartners.com/
https://www.bradysolicitors.com/property

Hospitality and Travel Websites:
https://thehideaways.co/
https://www.paradiseretreat.com.au/
https://www.farmhouseinn.com/
https://www.clearskybeachside.com/

Real Estate Websites:
https://www.rockethomes.com/
https://www.elliman.com/
https://www.knightfrank.com.pk/
https://www.sothebysrealty.co.nz/

Sports and Recreation Websites:
https://nhwatersport.nl/
https://www.rockethomes.com/
https://www.clearskybeachside.com/

Telecom and Electronics:
https://esp.com.mx/
https://cellularport.com/
https://store.cellularport.com/
https://www.nor-com.no/

Industrial and Manufacturing:
https://www.nor-com.no/
https://dgeng.com.au/
https://fantasiaenterprises.com/
https://constructkoin.com/

Education and Coaching Platforms:
https://www.theauditiontechnique.com/
https://www.creativelive.com/
https://www.futur.com/
https://www.coachhub.io/

Healthcare and Wellness:
https://gighealth.com/
https://www.humnutrition.com/
https://www.seed.com/
https://www.everlywell.com/

Media and Marketing:
https://oasnow.com/
https://www.wanderbrand.co/
https://www.fhoke.com/
https://www.superrb.com/

General Business Websites:
https://thewrightcos.com/
https://navitasconsultinggroup.com/
https://beexecutive.co.uk/
https://ccigroupcanada.com/`;

export const DEFAULT_NEW_SESSION_FORM = {
  name: 'Amin Warind',
  oauth_token: 'fV45CfQrlnOLqcRtpCIl5WmqAQ2nuK',
  groq_api_key: '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',
  model_name: 'qwen/qwen3-32b',
  service_offerings: DEFAULT_SERVICE_OFFERINGS,
  bid_writing_style: DEFAULT_BID_WRITING_STYLE,
  portfolio_links: DEFAULT_PORTFOLIO_LINKS,
  signature: 'Amin Warind.',
  bid_limit: 5,
  project_search_limit: 10,
  min_wait_time: 32,
  skill_ids: DEFAULT_SKILL_IDS_LIST,
  language_codes: 'en',
  unwanted_currencies: 'INR, PKR, BDT',
  unwanted_countries:
    'india, bangladesh, pakistan, jamaica, srilanka, sri lanka, nepal, south africa, kenya, uganda, egypt, indonesia, philippines, afganistan',
};
